import { motion } from "framer-motion";
import { Reveal, ease } from "@/lib/reveal";
import { useLang } from "@/lib/lang";

const scrollTo = (href) => {
  const el = document.querySelector(href);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

export default function Services() {
  const { t, lang } = useLang();
  return (
    <section className="pad section-line" id="services" data-testid="services-section">
      <Reveal className="eyebrow">{t.services.eyebrow}</Reveal>
      <Reveal delay={0.05}>
        <h2 className="big" style={{ maxWidth: 720, marginBottom: 64 }} data-testid="services-title">{t.services.title}</h2>
      </Reveal>

      <div className="cards" data-testid="services-cards">
        {t.services.cards.map((s, i) => (
          <motion.div
            className="card"
            key={i}
            data-testid={`service-card-${i}`}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, delay: i * 0.12, ease }}
          >
            <div className="cnum">{s.n}</div>
            <h3>{s.title}</h3>
            <p>{s.body}</p>
            <a href="#contact" className="clink" data-testid={`service-cta-${i}`}
              onClick={(e) => { e.preventDefault(); scrollTo("#contact"); }}>
              {lang === "he" ? `← ${s.cta}` : `${s.cta} →`}
            </a>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
